export default __webpack_public_path__ + "images/c399c7098a329ceef4e3819b2f92e7f9-ella-kahan.webp";